import { render } from "./NuevaLesionModal.vue?vue&type=template&id=7ce137fe"
import script from "./NuevaLesionModal.vue?vue&type=script&lang=js"
export * from "./NuevaLesionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__